import { render, staticRenderFns } from "./defaultPage.vue?vue&type=template&id=17460826&scoped=true"
import script from "./defaultPage.vue?vue&type=script&lang=js"
export * from "./defaultPage.vue?vue&type=script&lang=js"
import style0 from "./defaultPage.vue?vue&type=style&index=0&id=17460826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17460826",
  null
  
)

export default component.exports